<template>
  <aside class="mc-cfr">
    <div class="mc-cfr-title">Claim progress</div>
    <button
      v-for="(label, i) in steps"
      :key="label"
      type="button"
      class="mc-cfr-tab"
      :class="{
        'is-done': i + 1 < activeStep,
        'is-active': i + 1 === activeStep,
      }"
      :disabled="i + 1 >= activeStep"
      @click="$emit('jump', i + 1)"
    >
      <span class="mc-cfr-disc">
        <svg
          v-if="i + 1 < activeStep"
          width="11"
          height="11"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          stroke-width="3.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M20 6L9 17l-5-5" />
        </svg>
        <template v-else>{{ i + 1 }}</template>
      </span>
      <span class="mc-cfr-text">
        <b>{{ label }}</b>
        <span v-if="summaries[i + 1]">{{ summaries[i + 1] }}</span>
      </span>
    </button>

    <div class="mc-cfr-help">
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#B9691F"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path
          d="M4 5a1 1 0 011-1h3l2 5-2.5 1.5a11 11 0 005.5 5.5L15.5 14l5 2v3a1 1 0 01-1 1h-1C10.4 20 4 13.6 4 6V5z"
        />
      </svg>
      <div>
        <b>Need help?</b>
        <span>0709 912 000</span>
      </div>
    </div>
  </aside>
</template>

<script>
// Desktop/lg+ replacement for the horizontal ProgressRail — styled after the
// old ClaimFormStepper's white-card sidebar (blue only as an accent on the
// active step, not a solid colour block), but shows the new FNOL step list
// plus a one-line preview of what's been captured for each completed step.
export default {
  name: 'CaseFileRail',
  props: {
    steps: { type: Array, required: true },
    activeStep: { type: Number, required: true },
    // { [stepNumber]: 'one-line preview' }
    summaries: { type: Object, default: () => ({}) },
  },
}
</script>

<style scoped>
.mc-cfr {
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  background: #fff;
  border-right: 1px solid #e8e8e8;
  /* extra bottom padding keeps content clear of the full-width bottom bar
     that overlaps this column (see Shell.vue) — the white background still
     fills all the way down since padding paints with it, so the overlap
     with the (also white) bar is invisible rather than a visible gap */
  padding: 20px 18px 96px;
}

.mc-cfr-title {
  margin: 0 4px 12px;
  color: #14142b;
  font-size: 13px;
  font-weight: 800;
}

.mc-cfr-tab {
  display: grid;
  grid-template-columns: 26px minmax(0, 1fr);
  gap: 12px;
  align-items: flex-start;
  width: 100%;
  border: 0;
  border-radius: 10px;
  background: transparent;
  padding: 10px;
  margin-bottom: 3px;
  text-align: left;
  cursor: default;
}

.mc-cfr-tab.is-done {
  cursor: pointer;
}

.mc-cfr-tab.is-active {
  background: #eef3ff;
}

.mc-cfr-disc {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  margin-top: 1px;
  font-size: 11.5px;
  font-weight: 700;
  border: 1.5px solid #d9dbe9;
  background: #fff;
  color: #6e7191;
}

.mc-cfr-tab.is-active .mc-cfr-disc {
  border-color: #0066cc;
  background: #0066cc;
  color: #fff;
}

.mc-cfr-tab.is-done .mc-cfr-disc {
  border-color: #27ae60;
  background: #27ae60;
}

.mc-cfr-text {
  min-width: 0;
}

.mc-cfr-text b {
  display: block;
  font-size: 13.5px;
  font-weight: 700;
  color: #6e7191;
}

.mc-cfr-tab.is-active .mc-cfr-text b {
  color: #003087;
}

.mc-cfr-tab.is-done .mc-cfr-text b {
  color: #14142b;
}

.mc-cfr-text span {
  display: block;
  font-size: 11.5px;
  /* darker than the disc's grey — this can sit on the active tab's tinted
     background (#eef3ff), where the lighter tone fails contrast */
  color: #4e4b66;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mc-cfr-help {
  display: flex;
  gap: 11px;
  margin-top: auto;
  padding: 13px;
  border-radius: 12px;
  background: #fff8e8;
}

.mc-cfr-help svg {
  flex: 0 0 auto;
  margin-top: 1px;
}

.mc-cfr-help b {
  display: block;
  font-size: 12.5px;
  color: #14142b;
}

.mc-cfr-help span {
  display: block;
  font-size: 11.5px;
  color: #6e7191;
  font-weight: 600;
  margin-top: 1px;
}
</style>
